import { Alert, Form, Modal, Upload } from 'antd'
import { InboxOutlined } from '@ant-design/icons'
import * as React from 'react'
import moment from 'moment'

import { IConfigurazioneService } from '../../services/ConfigurazioneService'
import { IRaccoltaDatiService } from '../../services/RaccoltaDatiService'
import container from '../../wires/Bootstrapper'
import SERVICE_IDENTIFIER from '../../wires/Identifiers'

import { ContoCorrenteModel } from '../../models/ConfigurazioneModels'
import { RcCustomRequestOptions } from 'antd/lib/upload/interface'
import { FormInstance } from 'antd/lib/form'
import { TTModalProps } from '../shared/TTModalProps'

import { TTFormItem } from '../shared/TTFormItem'
import { TTSelect } from '../shared/TTSelect'
import { renderSelectModel } from '../shared/SelectOptionRenderUtils'
import { IApiService } from '../../services/shared/ApiService'

const { Dragger } = Upload

class ModalImportMovimentiState {
    ContiCorrenti: Array<ContoCorrenteModel>
    UploadEnabled: boolean = false
}

interface ModalImportMovimentiProps {
    periodo: Date
}

export class ModalImportMovimenti extends React.Component<TTModalProps & ModalImportMovimentiProps, ModalImportMovimentiState> {

    formRef = React.createRef<FormInstance>()

    service: IRaccoltaDatiService
    confService: IConfigurazioneService
    apiService: IApiService

    constructor(props) {
        super(props)

        this.service = container.get(SERVICE_IDENTIFIER.RACCOLTA_DATI_SERVICE)
        this.confService = container.get(SERVICE_IDENTIFIER.CONFIGURAZIONE_SERVICE)
        
        this.apiService = container.get(SERVICE_IDENTIFIER.API_SERVICE);
        this.state = new ModalImportMovimentiState()
    }

    componentDidMount() {
        this.loadCC()
    }

    loadCC = async () => {
        let resp = await this.confService.GetContiCorrenti()
        if (resp.IsValid == true)
            this.setState({ ContiCorrenti: resp.ContiCorrenti })
    }

    onContoChange = (e) => {
        this.setState({ UploadEnabled: e != null })
    }

    getSelectedCC = () => {
        return this.formRef.current.getFieldValue("ContoCorrente")
    }

    acceptedMimeTypes = () => {
        let list = [
            "application/vnd.ms-excel",
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        ]
        return list.join(",")
    }

    formatPeriodo = () => {
        return moment(this.props.periodo).format('MMMM YYYY')
    }

    uploadImage = async (options: RcCustomRequestOptions) => {
        const { onSuccess, onError, file } = options

        // Non può andare in eccezione perchè finchè il campo è vuoto l'upload è disabilitato
        let ccId = this.getSelectedCC()
        let resp = await this.service.ImportMovimenti(ccId, moment(this.props.periodo).format("YYYY/MM/DD") as any, file)
        if (resp.IsValid === true) {
            onSuccess(resp, file)
            this.props.closeModal()
            this.props.do()
        } else {
            const error = new Error(resp.Notifies[0].Message)
            onError(error)
        }
    };

    renderUploadHint = () => {
        if (this.state.UploadEnabled == true) return

        return (
            <p className="ant-upload-hint">
                Seleziona il conto corrente per abilitare il caricamento del file
            </p>
        )
    }

    downloadExapleFile = () => {
        this.apiService.downloadFile("/api/Utility/GetSampleFile");
    }

    render() {
        return (
            <Modal
                title="Importazione movimenti"
                width={600}
                visible={this.props.visible}
                onCancel={this.props.closeModal}
                footer={null}>
                <Alert
                    type="warning"
                    showIcon
                    message={`Verranno importati solo i movimenti di ${this.formatPeriodo()}`}
                    description={<div>
                                    <span>Se nel file sono presenti movimenti di altri mesi, questi verranno ignorati</span>
                                    <br/>
                                        <a onClick={() => this.downloadExapleFile () } >Scarica il file di esempio </a>
                                </div>
                                } />
                <br />
                Seleziona il conto corrente dal quale stai importando i movimenti e successivamente carica il file excel per iniziare l'importazione.
                <br />
                <br />
                <Form ref={this.formRef}>
                    <TTFormItem name="ContoCorrente" label="Conto corrente" rules={[{ required: true }]}>
                        <TTSelect onChange={e => this.onContoChange(e)}>
                            {renderSelectModel(this.state.ContiCorrenti, "Id", "Descrizione")}
                        </TTSelect>
                    </TTFormItem>
                </Form>


                <Dragger
                    accept={this.acceptedMimeTypes()}
                    showUploadList={false}
                    customRequest={options => this.uploadImage(options)}
                    disabled={this.state.UploadEnabled == false}>
                    <p className="ant-upload-drag-icon">
                        <InboxOutlined />
                    </p>
                    <p className="ant-upload-text">Clicca o trascina il file in quest'area per caricarlo</p>
                    {this.renderUploadHint()}
                </Dragger>
            </Modal>
        )
    }
}